(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function FaqItem(el, group) {
      this.el = el;
      this.group = group;
      this.summary = el.querySelector('.faq__question');
      this.animation = null;
      this.isClosing = false;

      // The script owns exclusivity from here on, so the native `name`
      // grouping cannot slam the previous answer shut mid-animation.
      el.removeAttribute('name');
      this.summary.addEventListener('click', this.onClick.bind(this));
    }

    // Height the element settles at with only the summary showing.
    FaqItem.prototype.closedHeight = function () {
      var borders = this.el.offsetHeight - this.el.clientHeight;
      return this.summary.offsetHeight + borders;
    };

    // Height it wants when fully open, measured with a real layout pass so
    // borders and box-sizing are accounted for.
    FaqItem.prototype.openHeight = function () {
      var previous = this.el.style.height;
      this.el.style.height = 'auto';
      var height = this.el.offsetHeight;
      this.el.style.height = previous;
      return height;
    };

    FaqItem.prototype.onClick = function (event) {
      event.preventDefault();

      if (reducedMotion()) {
        this.el.open = !this.el.open;
        if (this.el.open) this.group.closeOthers(this);
        return;
      }

      if (this.isClosing || !this.el.open) {
        this.expand();
      } else {
        this.shrink();
      }
    };

    FaqItem.prototype.expand = function () {
      var self = this;

      this.el.style.height = this.el.offsetHeight + 'px';
      this.el.open = true;
      this.group.closeOthers(this);

      window.requestAnimationFrame(function () {
        self.animate(self.el.offsetHeight, self.openHeight(), true);
      });
    };

    FaqItem.prototype.shrink = function () {
      this.isClosing = true;
      this.animate(this.el.offsetHeight, this.closedHeight(), false);
    };

    FaqItem.prototype.animate = function (from, to, willBeOpen) {
      var self = this;

      if (this.animation) {
        // Drop the handlers before cancelling: oncancel fires asynchronously
        // and would otherwise reset the state of the animation replacing it.
        this.animation.onfinish = null;
        this.animation.oncancel = null;
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        { height: [from + 'px', to + 'px'] },
        { duration: DURATION, easing: EASING }
      );

      this.animation.onfinish = function () {
        self.el.open = willBeOpen;
        self.reset();
      };

      this.animation.oncancel = function () {
        self.reset();
      };
    };

    FaqItem.prototype.reset = function () {
      this.animation = null;
      this.isClosing = false;
      this.el.style.height = '';
    };

    function FaqGroup(root) {
      var self = this;

      this.exclusive = root.getAttribute('data-faq-exclusive') === 'true';
      this.items = [];

      Array.prototype.forEach.call(root.querySelectorAll('.faq__item'), function (el) {
        self.items.push(new FaqItem(el, self));
      });
    }

    FaqGroup.prototype.closeOthers = function (except) {
      if (!this.exclusive) return;

      this.items.forEach(function (item) {
        if (item === except || !item.el.open || item.isClosing) return;

        if (reducedMotion()) {
          item.el.open = false;
        } else {
          item.shrink();
        }
      });
    };

    function init(scope) {
      var root = scope || document;

      Array.prototype.forEach.call(root.querySelectorAll('[data-faq]'), function (el) {
        if (el.hasAttribute('data-faq-ready')) return;
        el.setAttribute('data-faq-ready', '');
        new FaqGroup(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    // Re-init when re-rendered inside the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-full-product-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpicyHero(hero) {
      if (!hero || hero.dataset.spicyHeroInit === 'true') {
        return;
      }
      hero.dataset.spicyHeroInit = 'true';

      // No IntersectionObserver support: just reveal it.
      if (!('IntersectionObserver' in window)) {
        hero.classList.add('is-inview');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(hero);
    }

    function initAll() {
      document.querySelectorAll('.spicy-hero').forEach(initSpicyHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when re-rendered inside the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      initSpicyHero(event.target.querySelector('.spicy-hero'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
